import React, { memo, useCallback } from 'react';

import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

import { AiChatTestIds } from '../../../../../AiChat.testIds';

import {
  confirmActionButtonStyles,
  confirmActionContainerStyles,
} from './ConfirmActionContent.styles';
import { formatConfirmActionContentCopyText } from './ConfirmActionContent.utils';

const ConfirmActionContent = ({ contentProps, onCopy }) => {
  const handleCopy = useCallback(() => {
    onCopy(formatConfirmActionContentCopyText(contentProps.submitLabel, contentProps.cancelLabel));
  }, [contentProps.submitLabel, contentProps.cancelLabel, onCopy]);

  return (
    <Box
      data-testid={AiChatTestIds.CONFIRM_ACTION_CONTENT}
      sx={confirmActionContainerStyles}
      onClick={handleCopy}
    >
      <Button
        color="primary"
        data-testid={AiChatTestIds.CONFIRM_ACTION_CONTENT_SUBMIT_BUTTON}
        sx={confirmActionButtonStyles}
        onClick={contentProps.onSubmit}
      >
        {contentProps.submitLabel}
      </Button>
      <Button
        color="inherit"
        data-testid={AiChatTestIds.CONFIRM_ACTION_CONTENT_CANCEL_BUTTON}
        sx={confirmActionButtonStyles}
        variant="outlined"
        onClick={contentProps.onCancel}
      >
        {contentProps.cancelLabel}
      </Button>
    </Box>
  );
};

ConfirmActionContent.propTypes = {
  contentProps: PropTypes.shape({
    submitLabel: PropTypes.string.isRequired,
    cancelLabel: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }).isRequired,
  onCopy: PropTypes.func.isRequired,
};

export default memo(ConfirmActionContent);
